<button class="location form-control" (click)="toggle()">
    <i class="las la-map-marker-alt text-grad"></i>
    <span class="px-2 text-truncate">{{ selectedState }}</span>
    <i class="las la-angle-down"></i>
</button>

<div class="menu" [ngClass]="{ show: show, hide: !show }" >
  <div  class="item" role="button" (click)="selectState(null)">
      <div class="image bg-grad position-relative">
        <span class="imageText">BR</span>
      </div>
      <div class="label">
          <p class="city ms-2 m-0">Tudo</p>
      </div>
  </div>
    <div *ngFor="let state of states">
      <div  class="item" role="button" (click)="selectState(state)">
          <div class="image bg-grad position-relative">
            <span class="imageText">{{ state.uf }}</span>
          </div>
          <div class="label">
              <p class="city ms-2 m-0">{{ state.name }}</p>
          </div>
      </div>
    </div>
</div>

<bs-modal-backdrop class="modal-backdrop fade in show" (click)="toggle()" *ngIf="show"></bs-modal-backdrop>
